import React, {PropsWithChildren} from "react";


class ContentErrorBoundary extends React.Component<PropsWithChildren<{contentPage:string}>, { error: any}> {
    constructor(props:{contentPage:string}) {
        super(props);
        this.state = { error: null }
    }
    static getDerivedStateFromError(error:any) {
        return { error: error };
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {

    }

    render() {
        if (this.state.error) {
            const errorString = this.state.error.message !== undefined ? this.state.error.message : this.state.error;
            return <main>
                <h1>Error in {this.props.contentPage}</h1>
                <p>{ errorString }</p>
            </main>;
        }
        return this.props.children;
    }

}
export default ContentErrorBoundary;